import { PdfScaleState } from '@app/libs/reactPdfJs/store/reducers/scale';
import { RootState } from '@app/store/types';

const getPdf = (state: RootState) => state.pdf;

export const currentPageNumberSelector = (state: RootState): number =>
  getPdf(state).currentPageNumber;

export const defaultScaleSelector = (state: RootState) => getPdf(state).defaultScale;

export const getErrorMessage = (state: RootState) => getPdf(state).errorMessage;

export const getLoadingStatus = (state: RootState) => getPdf(state).loadingStatus;

export const lastNavigatePageSelector = (state: RootState) => getPdf(state).lastNavigatePage;

export const maxScaleSelector = (state: RootState) => getPdf(state).maxScale;

export const minScaleSelector = (state: RootState) => getPdf(state).minScale;

export const scaleSelector = (state: RootState): PdfScaleState => getPdf(state).scale;

export const pageLeftPositionsSelector = (state: RootState) => getPdf(state).pageLeftPositions;

export const pageViewportSizesSelector = (state: RootState) => getPdf(state).pageViewportSizes;

export const viewerScaleSelector = (state: RootState) => getPdf(state).viewerScale;

export const viewerPinchDisabledSelector = (state: RootState) => getPdf(state).viewerPinchDisabled;

export const getCurrentPageLeftPosition = (state: RootState): number =>
  pageLeftPositionsSelector(state)[currentPageNumberSelector(state) - 1] ?? 0;

export const getPdfMaxPage = (state: RootState) => pageViewportSizesSelector(state).length;
